import React, { ReactNode, useEffect } from 'react';
import bem from '../../../lib/bemUtils/bem';

/**
 * This component creates two live region and alternates between them.
 * This is done to solve the problem that changes within the live region are
 * read multiple times due to the way react manipulates the dome when a
 * component is changed.
 *
 * @see https://github.com/nvaccess/nvda/issues/7996
 */

type LiveRegionType = {
  htmlTag?: 'div' | 'span';
  children?: ReactNode | string;
  modifier?: any;
  invisible?: boolean;
  ariaLive?: 'polite' | 'assertive';
  ariaRole?: 'alert' | 'status' | null;
  ariaRelevant?: 'additions' | 'removals';
  ariaAtomic?: true | false;
};
export default function LiveRegion({
  htmlTag = 'span',
  modifier,
  invisible = true,
  ariaLive = 'polite',
  ariaRole,
  ariaRelevant,
  ariaAtomic,
  children,
}: LiveRegionType) {
  let alternate = false;

  useEffect(() => {
    alternate = !alternate;
  }, [children]);

  const renderLiveRegion = (classes: string[], SpanOrDiv: any, renderMessage: boolean) => {
    return (
      <SpanOrDiv
        className={classes.join(' ')}
        role={ariaRole}
        aria-live={ariaLive}
        aria-atomic={ariaAtomic}
        aria-relevant={ariaRelevant}
      >
        {renderMessage ? children : null}
      </SpanOrDiv>
    );
  };

  const SpanOrDiv = htmlTag;
  const classes = [bem('live-region', modifier)];

  if (invisible) {
    classes.push('invisible');
  }

  return (
    <>
      {renderLiveRegion(classes, SpanOrDiv, alternate)}
      {renderLiveRegion(classes, SpanOrDiv, !alternate)}
    </>
  );
}

LiveRegion.modifier = {};
